import { settings } from '../../config/settingsFactory.mjs';
import { InfoBarComponent } from './InfoBarComponent.jsx';
import { getValidSetting, sanitizeHtml } from '../../utils/common.mjs';

const parseIcon = (icon) => icon && icon.includes('/') ? { type: icon.split('/')[0], name: icon.split('/')[1] } : false;

const isInfobarClosed = (infoBarKey, infoBarExpiryKey) => {
    const closed = localStorage.getItem(infoBarKey) === 'true';
    const expiry = localStorage.getItem(infoBarExpiryKey);
    console.log('isInfobarClosed: ', closed, expiry);
    if (closed && expiry) {
        const now = new Date().getTime();
        if (now > expiry) {
            localStorage.removeItem(infoBarKey);
            localStorage.removeItem(infoBarExpiryKey);
            return false;
        }
    }
    return closed;
}

export const initInfoBar = (isPublic) => {
  var infoBarSettings = isPublic
    ? settings.clientSettings?.infoBarPublic
    : settings.clientSettings?.infoBarPrivate;
  const infoBarKey = isPublic
    ? "public-infobar-banner-closed"
    : "private-infobar-banner-closed";
  const infoBarExpiryKey = isPublic
    ? "public-infobar-banner-closed-expiry"
    : "private-infobar-banner-closed-expiry";
  const now = new Date().getTime();
  const campaignDeadline = getValidSetting(
    infoBarSettings.campaignDeadline,
    now,
    "infoBarSettings.campaignDeadline"
  ); // campaign will not start at all if the deadline is not set or is not readable (default = now)
  console.log("initInfoBar: ", infoBarSettings, campaignDeadline);
  var campaignIsActive =
    getValidSetting(infoBarSettings?.active, false, "infoBarSettings.active") &&
    (campaignDeadline > now ? true : false);

  if (!isInfobarClosed(infoBarKey, infoBarExpiryKey) && campaignIsActive) {
    const infobarContainer = document.getElementById("infobar-container");
    const icon = getValidSetting(
      infoBarSettings.icon,
      false,
      "infoBarSettings.icon"
    );
    let rawMessage = getValidSetting(
      infoBarSettings.message,
      [],
      "infoBarSettings.message"
    );
    let message = Array.isArray(rawMessage) ? rawMessage : [rawMessage];

    const infobar = InfoBarComponent({
      id: "campaign",
      variant: getValidSetting(
        infoBarSettings.variant,
        "info",
        "infoBarSettings.variant"
      ),
      inverse: getValidSetting(
        infoBarSettings.inverse,
        false,
        "infoBarSettings.inversion"
      ),
      closable: getValidSetting(
        infoBarSettings.closable,
        true,
        "infoBarSettings.closable"
      ),
      icon: parseIcon(icon),
    });

    infobarContainer.appendChild(infobar);
    const InfoBarComponentP = document.getElementById("InfoBarComponentP-campaign");
    InfoBarComponentP.innerHTML = sanitizeHtml(
      message.map((m) => `<p>${m}</p>`).join("")
    );
    const InfoBarButton = document.getElementById("infoBarButton");

    if (InfoBarButton) {
      InfoBarButton.addEventListener("gov-click", () => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const userData = urlParams.get("userData")?.toLowerCase();
        window.location.href = `${infoBarSettings.onButtonClickAction}${userData}`;
      });
    }

    document.getElementById("infobar-campaign").addEventListener("gov-close", () => {
      infobar.style.display = "none";
      localStorage.setItem(infoBarKey, "true");
      localStorage.setItem(infoBarExpiryKey, campaignDeadline);
    });
  }

  // If there is a valid message in the backend system settings, override the local campaign data
  if (settings.serverTechSettings.messages?.length) {
    infoBarSettings.message = settings.serverTechSettings.messages;
    infoBarSettings.icon = "basic/exclamation-triangle-fill"; // Default icon for info bar
    infoBarSettings.variant = "warning"; // Default variant for info bar
    infoBarSettings.inverse = false;
    infoBarSettings.closable = true; // Always on since backend system message is storing the state in sessionStorage
    campaignIsActive = true; // Always show the message if it is set in system settings

    if (
      sessionStorage.getItem("public-infobar-banner-closed") !== "true" &&
      campaignIsActive
    ) {
      const infobarContainer = document.getElementById("infobar-container");
      const icon = getValidSetting(
        infoBarSettings.icon,
        false,
        "infoBarSettings.icon"
      );
      let rawMessage = getValidSetting(
        infoBarSettings.message,
        [],
        "infoBarSettings.message"
      );
      let message = Array.isArray(rawMessage) ? rawMessage : [rawMessage];

      const infobar = InfoBarComponent({
        id: "maintenance",
        variant: getValidSetting(
          infoBarSettings.variant,
          "info",
          "infoBarSettings.variant"
        ),
        inverse: getValidSetting(
          infoBarSettings.inverse,
          false,
          "infoBarSettings.inversion"
        ),
        closable: getValidSetting(
          infoBarSettings.closable,
          true,
          "infoBarSettings.closable"
        ),
        icon: parseIcon(icon),
      });

      infobarContainer.appendChild(infobar);
      const InfoBarComponentP = document.getElementById("InfoBarComponentP-maintenance");
      InfoBarComponentP.innerHTML = sanitizeHtml(
        message.map((m) => `<p>${m}</p>`).join("")
      );
      const InfoBarButton = document.getElementById("infoBarButton");

      if (InfoBarButton) {
        InfoBarButton.addEventListener("gov-click", () => {
          const queryString = window.location.search;
          const urlParams = new URLSearchParams(queryString);
          const userData = urlParams.get("userData")?.toLowerCase();
          window.location.href = `${infoBarSettings.onButtonClickAction}${userData}`;
        });
      }

      document.getElementById("infobar-maintenance").addEventListener("gov-close", () => {
        infobar.style.display = "none";
        sessionStorage.setItem("public-infobar-banner-closed", "true");
      });
    }
  }
}
